import React, { useContext } from "react";
import { LegacyCard as Card, RadioButton, Select, BlockStack, InlineStack, TextField, Text } from "@shopify/polaris";

// import constant
import constant from "lib/constant/constant";

// import propType
import { PrivateContext } from "lib/context";
import { offerConditionProp } from "app/shipping/modules/operator/features/offer/propTypes";

const RenderOfferCondition = (props) => {
  const {
    handleConditionChange,
    isConditionApplied,
    shippingOffer,
    handleCriteria,
    handleCondition,
    moneyFormat,
  } = props;
  const { cms } = useContext(PrivateContext);
  const isProductPrice = shippingOffer.condition === constant.PRODUCT_PRICE;
  const isProductQuantity = shippingOffer.condition === constant.PRODUCT_QUANTITY;
  const isOrderValue = shippingOffer.condition === constant.ORDER_VALUE;

  const criteriaText =
    (isProductPrice && cms("offer.add.section.condition.label.priceShouldBe")) ||
    (isProductQuantity && cms("offer.add.section.condition.label.quantityShouldBe")) ||
    cms("offer.add.section.condition.label.orderValueShouldBe");

  const criteriaValues =
    (isProductPrice && shippingOffer.productPrice) ||
    (isProductQuantity && shippingOffer.productQuantity) ||
    (isOrderValue && shippingOffer.orderValue) ||
    {};

  const criteriaKey =
    (isProductPrice && constant.PRODUCT_PRICE) ||
    (isProductQuantity && constant.PRODUCT_QUANTITY) ||
    constant.ORDER_VALUE;

  const conditionOptions = [
    {
      key: constant.PRODUCT_PRICE,
      label: cms("label.productPrice"),
      value: constant.PRODUCT_PRICE,
    },
    {
      key: constant.PRODUCT_QUANTITY,
      label: cms("label.productQuantity"),
      value: constant.PRODUCT_QUANTITY,
    },
    {
      key: constant.ORDER_VALUE,
      label: cms("label.orderValue"),
      value: constant.ORDER_VALUE,
    },
  ];

  const offerCriteriaOptions = [
    { key: constant.GREATER_THAN, label: cms("label.greaterThan"), value: constant.GREATER_THAN },
    { key: constant.LESS_THAN, label: cms("label.lessThan"), value: constant.LESS_THAN },
  ];

  return (
    <Card sectioned title={cms("modal.offer.add.section.condition.label.offerCondition")}>
      <BlockStack gap="400">
        <BlockStack>
          <RadioButton
            id="allConditions"
            name="allConditions"
            label={cms("modal.offer.add.section.condition.label.allConditions")}
            helpText={cms("modal.offer.add.section.condition.caption.allCondition")}
            checked={!isConditionApplied}
            onChange={handleConditionChange}
          />
          <RadioButton
            id="selectedConditions"
            name="selectedConditions"
            label={cms("modal.offer.add.section.condition.label.selectedCondition")}
            helpText={cms("modal.offer.add.section.condition.caption.selectedCondition")}
            checked={isConditionApplied}
            onChange={handleConditionChange}
          />
        </BlockStack>
        <BlockStack>
          {isConditionApplied && (
            <>
              <Select
                id="shippingCondition"
                name="shippingCondition"
                options={conditionOptions}
                placeholder={`${cms("modal.offer.add.section.condition.placeHolder.selectShippingOffer")} *`}
                value={shippingOffer.condition || ""}
                onChange={handleCondition}
              />
              {(isProductPrice || isProductQuantity || isOrderValue) && (
                <>
                  <br />
                  <InlineStack gap="400">
                    <Text as="span">{criteriaText}</Text>
                    <Select
                      id="criteria"
                      key="criteria"
                      options={offerCriteriaOptions}
                      placeholder={cms("modal.offer.add.section.condition.placeHolder.selectCriteria")}
                      value={criteriaValues.criteria || ""}
                      onChange={(val) => handleCriteria(criteriaKey, "criteria", val)}
                    />
                    <TextField
                      id="criteriaValue"
                      type="number"
                      placeholder={cms("modal.offer.add.section.condition.placeHolder.selectCriteria")}
                      value={(criteriaValues.value && criteriaValues.value.toString()) || ""}
                      min={constant.value.MIN_PRICE}
                      step={isProductPrice || isOrderValue ? constant.value.STEP : constant.value.MIN_PRICE}
                      prefix={(isProductPrice || isOrderValue) && moneyFormat}
                      onChange={(val) => handleCriteria(criteriaKey, "value", val)}
                    />
                  </InlineStack>
                </>
              )}
            </>
          )}
        </BlockStack>
      </BlockStack>
    </Card>
  );
};

RenderOfferCondition.propTypes = offerConditionProp.type;

export default RenderOfferCondition;
